import { render, staticRenderFns } from "./VDialogAction.vue?vue&type=template&id=0a4ca8a3"
import script from "./VDialogAction.vue?vue&type=script&lang=js"
export * from "./VDialogAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4ca8a3')) {
      api.createRecord('0a4ca8a3', component.options)
    } else {
      api.reload('0a4ca8a3', component.options)
    }
    module.hot.accept("./VDialogAction.vue?vue&type=template&id=0a4ca8a3", function () {
      api.rerender('0a4ca8a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VDialog/VDialogAction.vue"
export default component.exports